module.exports = __webpack_public_path__ + "img/17.cloudy-night-stars-light.096a0873.svg";